import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
  {
    // 大众常见问题
    path: '/commonProblemsVW',
    name: 'commonProblemsVW',
    component: () =>
      import(/* webpackChunkName: "commonProblemsVW" */ '@/views/svw/help-center/HelpCenter.vue')
  },
  {
    // 大众常见问题v2
    path: '/commonProblemsVWV2',
    name: 'commonProblemsVWV2',
    component: () =>
      import(/* webpackChunkName: "CustomerServiceVWV2" */ '@/views/svw/help-center/HelpCenter.vue')
  },
  {
    // 大众问题详情
    path: '/commonProblemsVWV2/detailVW',
    name: 'commonProblemsDetailVWV2',
    component: () =>
      import(
        /* webpackChunkName: "commonProblemsDetailVWV2" */ '@/views/svw/help-center/Detail.vue'
      ),
    meta: {
      cname: '问题详情'
    }
  },
  {
    // 大众常见问题
    path: '/allProblemsVW/:id?',
    name: 'allProblemsVW',
    component: () =>
      import(/* webpackChunkName: "allProblemsVW" */ '@/views/svw/help-center/AllQuestion.vue'),
    meta: {
      cname: '全部问题'
    }
  },
  {
    // 大众月度推荐
    path: '/svw/recommand-feature',
    name: 'svwRecommandFeature',
    component: () =>
      import(
        /* webpackChunkName: "svwRecommandFeature" */ '@/views/svw/help-center/RecommandFeature.vue'
      ),
    meta: {
      cname: '功能介绍'
    }
  },
  {
    // 大众停服通知
    path: '/userInformVW',
    name: 'userVWuserInformVWInform',
    component: () => import(/* webpackChunkName: "userInformVW" */ '@/views/svw/vwNotify.vue')
  },
  {
    // 大众功能迁移
    path: '/migrationVW',
    name: 'migrationVW',
    component: () => import(/* webpackChunkName: "migrationVW" */ '@/views/svw/migrationVW.vue')
  },
  {
    // 搜索问题
    path: '/searchQuestionVW',
    name: 'searchQuestionVW',
    component: () =>
      import(
        /* webpackChunkName: "searchQuestionVW" */ '@/views/svw/help-center/SearchQuestion.vue'
      ),
    meta: {
      cname: '帮助中心'
    }
  },
  {
    path: '/vw/activity/month-report',
    name: 'vwMonthReport',
    component: () =>
      import(/* webpackChunkName: "vwMonthReport" */ '@/views/svw/activities/monthSum/index.vue'),
    meta: {
      cname: '上汽大众月报'
    }
  },
  {
    path: '/vw/activity/month-recommand-detail',
    name: 'vwMonthRecommandDetail',
    component: () =>
      import(
        /* webpackChunkName: "vwMonthDetail" */ '@/views/svw/activities/monthSum/RecommandDetail.vue'
      ),
    meta: {
      cname: '上汽大众月报推荐详情'
    }
  },
  {
    path: '/vw/activity/one-page',
    name: 'vwOnePage',
    component: () =>
      import(/* webpackChunkName: "vwMonthReport" */ '@/views/svw/activities/onePage.vue'),
    meta: {
      cname: '上汽大众单图片页面'
    }
  },
  {
    path: '/vw/activity/month-guide',
    name: 'vwMonthReportGuide',
    component: () =>
      import(
        /* webpackChunkName: "vwMonthReportGuide" */ '@/views/svw/activities/monthSum/KindGuide.vue'
      ),
    meta: {
      cname: '上汽大众月度报告页面'
    }
  },
  {
    path: '/vw/activity/month-recommand',
    name: 'vwMonthRecommand',
    component: () =>
      import(
        /* webpackChunkName: "vwMonthRecommand" */ '@/views/svw/activities//monthSum/MonthRecommend.vue'
      ),
    meta: {
      cname: '上汽大众月度推荐页面'
    }
  },
  {
    path: '/vw/activity/user-recruit',
    name: 'vwUserRecruit',
    component: () =>
      import(
        /* webpackChunkName: "vwUserRecruit" */ '@/views/svw/activities/userRecruit/index.vue'
      ),
    meta: {
      cname: '上汽大众用户招募'
    }
  },
  {
    path: '/vw/activity/2025-report',
    name: 'vwReport2025',
    component: () =>
      import(
        /* webpackChunkName: "repoer2025" */ '@/views/svw/activities/2025-report/2025-sum.vue'
      ),
    meta: {
      cname: '2025年大众年报'
    }
  },
  {
    path: '/activity/report-2024',
    name: 'nativejs',
    component: () =>
      import(/* webpackChunkName: "repoer2024" */ '@/views/svw/activities/2024-sum.vue'),
    meta: {
      cname: '2024年大众年报'
    }
  },
  {
    path: '/vw/guide',
    name: 'vwGuide',
    component: () => import(/* webpackChunkName: "vwGuide" */ '@/views/svw/activities/guide.vue'),
    meta: {
      cname: '上汽大众引导页面'
    }
  },
  //-------------------------------------活动页面------------------------------------
  {
    // 活动页面
    path: '/purchaseVW',
    name: 'purchaseVW',
    component: () =>
      import(/* webpackChunkName: "purchaseVW" */ '@/views/svw/activities/purchaseVW.vue')
  },
  {
    path: '/intelligent-unlockingVW',
    name: 'intelligentUnlockingWithAppVW',
    component: () =>
      import(/* webpackChunkName: "SmartLockerManualVW" */ '@/views/svw/SmartLockerManual.vue'),
    meta: {
      cname: '智能解闭锁'
    },
    props: true
  }
];
export default routes;
